// extracted by mini-css-extract-plugin
export default {"wrapper":"Chart_wrapper__Y8p+B","chart":"Chart_chart__gKBLL"};